<template>
    <Card :title="$t('currentPatentList')" class="mt-3 min-h-[460px]">
        <div class="h-[90%] w-full overflow-y-auto">
            <!-- header -->
            <div class="flex min-h-[48px] flex-row flex-nowrap items-center gap-2 border-b border-b-grey-40 bg-blue-40 px-6 text-xs font-bold text-eureka-600">
                <div class="w-1/12">{{ $t('no') }}</div>
                <div class="w-2/12 shrink-0">{{ $t('pn') }}️</div>
                <div class="w-1/12 shrink-0">{{ $t('similarity') }}️</div>
                <div class="w-3/12">{{ $t('title') }}</div>
                <div class="w-3/12">{{ $t('relevantPart') }}</div>
                <div class="w-2/12 min-w-[80px]">{{ $t('apd') }}</div>
            </div>
            <!-- body -->
            <div
                v-for="(patent, idx) in props.list"
                :key="patent.pn"
                class=" flex min-h-[48px] flex-row flex-nowrap items-center gap-2 px-6 text-xs text-black odd:bg-grey-20"
            >
                <div class="w-1/12">{{ idx + 1 }}</div>
                <div class="w-2/12 shrink-0">{{ patent.pn || '-' }}</div>
                <div class="w-1/12 shrink-0">{{ patent.similarity || '-' }}️</div>
                <div class="w-3/12">{{ patent.title || '-' }}</div>
                <div class="w-3/12">{{ patent.relate || '-' }}</div>
                <div class="w-2/12 min-w-[80px]">{{ patent.pbd || '-' }}</div>
            </div>
        </div>
    </Card>
</template>

<script setup lang="ts">
import Card from '../Card.vue'
import type { IReportPatent } from '@/types';
const props = defineProps<{
    list: IReportPatent[]
}>();

</script>
